const URL_API = "https://api.whizztanzania.com/v1/";
// const URL_API = "http://localhost/moncongo-api/v1/"


export default URL_API;